import { useSelector } from 'react-redux';
import { EntityId } from '@reduxjs/toolkit';
import { isFavoriteSelector } from './selectors';
import { FavoritesReducerStateShape } from './slice';

export const useIsFavorite = (clientId: EntityId): boolean => {
  return useSelector<FavoritesReducerStateShape, boolean>((state) => isFavoriteSelector(state, clientId));
};
